import React from "react";
import styled from "styled-components";
import FieldErrorMessage from "./FieldErrorMessage";
import FieldLabel from "./FieldLabel";
import FieldHelpText from "./FieldHelpText";

const RadioFieldGroup = (props: Props) => {
  const {
    children,
    label,
    helpText,
    vertical = false,
    name,
    hiddenLabel,
  } = props;

  return (
    <RadioGroupWrapper>
      <FieldLabel visuallyHidden={hiddenLabel}>
        {label}
        {helpText && <FieldHelpText>{helpText}</FieldHelpText>}
      </FieldLabel>
      <RadioGroup vertical={vertical}>{children}</RadioGroup>
      <FieldErrorMessage name={name} />
    </RadioGroupWrapper>
  );
};

type Props = {
  children: React.ReactChild[];
  name: string;
  label: string;
  vertical?: boolean;
  helpText?: string;
  hiddenLabel?: boolean;
};

const RadioGroupWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1.5rem;
`;

const RadioGroup = styled.div<{
  vertical: boolean;
}>`
  display: flex;
  flex-direction: ${({ vertical }) => (vertical ? "column" : "row")};
  flex-wrap: wrap;
  flex: 1;

  align-items: ${({ vertical }) => !vertical && "center"};
  justify-content: ${({ vertical }) => vertical && "center"};

  > * {
    &:not(:first-child) {
      ${({ vertical }) => (vertical ? "margin-top" : "margin-left")}: 1rem;
    }
  }
`;

export default RadioFieldGroup;
